import { Tab } from "semantic-ui-react";
import type { FoodOrder } from "types";

import GetBalance from "./getBalance";
import MakePayment from "./makePayment";
import PastPayments from "./pastPayments"

/**
 * What the Solutran tab group accepts.
 *
 * Every field is forwarded unchanged to `MakePayment` or `PastPayments`, so
 * `ComponentProps` takes the types from their props.
 *
 * `view` is this component's own: `food/index.tsx` holds it as a bare
 * `useState()`, so its type is the two views plus the `undefined`/`null` the
 * parent seeds and clears it with.
 */
type SolutranProps = Pick<
    React.ComponentProps<typeof MakePayment>,
    'ordersData' | 'ordersMutate' | 'org' | 'setView' | 'solutranMakePaymentSelectedOrder' | 'setSolutranMakePaymentSelectedOrder'
> &
    Pick<
        React.ComponentProps<typeof PastPayments>,
        'solutranPastPaymentsSelectedOrder' | 'setSolutranPastPaymentsSelectedOrder'
    > & {
        view?: 'makePayment' | 'pastPayments' | null | undefined;
    };

export default function Solutran(props: SolutranProps) {

    const getView = () => {
        switch (props.view) {
            case "makePayment":
                return 1
            case "pastPayments":
                return 2
            default:
                return 0
        }
    }

    return (
        <Tab defaultActiveIndex={getView()} panes={[
            {
                menuItem: 'Get Balance',
                render: () =>
                    <Tab.Pane>
                        <GetBalance />
                    </Tab.Pane>
            },
            {
                menuItem: 'Make Payment',
                render: () =>
                    <Tab.Pane>
                        <MakePayment
                            ordersData={props.ordersData}
                            ordersMutate={props.ordersMutate}
                            org={props.org}
                            setView={props.setView}
                            solutranMakePaymentSelectedOrder={props.solutranMakePaymentSelectedOrder}
                            setSolutranMakePaymentSelectedOrder={props.setSolutranMakePaymentSelectedOrder}
                        />
                    </Tab.Pane>
            },
            {
                menuItem: 'Past Payments',
                render: () =>
                    <Tab.Pane>
                        <PastPayments
                            paidOrders={props.ordersData?.filter((o: FoodOrder) => o.payments)}
                            ordersMutate={props.ordersMutate}
                            setView={props.setView}
                            solutranPastPaymentsSelectedOrder={props.solutranPastPaymentsSelectedOrder}
                            setSolutranPastPaymentsSelectedOrder={props.setSolutranPastPaymentsSelectedOrder}
                        />
                    </Tab.Pane>
            },
        ]} />
    )
}